// extracted by mini-css-extract-plugin
export default {"wrapper":"CopyableCode_wrapper__ckTuK","code":"CopyableCode_code__xDJsU","copyBtn":"CopyableCode_copyBtn__YEOAF"};